/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateFamilyExtraConfigBackfill} from '../api'

export const useMutationUpdateFamilyExtraConfigBackfill = createReactQueryMutationHook('updateFamilyExtraConfigBackfill', updateFamilyExtraConfigBackfill)
